import {computed} from "vue";

const useQueriesState = (queries) => {
  const isLoading = computed(() => queries.value?.some(q => q.isLoading) || false);
  const isError = computed(() => queries.value?.some(q => q.isError) || false);

  const data = computed(() => queries.value[0]?.data);
  const comparedData = computed(() => queries.value[1]?.data);

  return {
    isLoading,
    isError,
    data,
    comparedData,
  };
};

export default useQueriesState;
